export const convertPoseStringIntoArray = function(paramString = ''){

  const sectionCount = 32;

  const posesPerSection = [3,3,1,2,2,1,2,2,1,3,2,2,1,3,2,2,1,3,2,2,1,3,2,2,1,1,1,1,1,1,1];
  while (posesPerSection.length < sectionCount) {
    posesPerSection.push(1);
  }

  const sectionArray = (paramString.length === 0) ? [] : paramString.split("+");

  for (var i=0; i<sectionCount; i++){
    if (i >= sectionArray.length) {
      if (posesPerSection[i] === 1) {
          sectionArray[i]="_";
      } else if (posesPerSection[i] === 2){
          sectionArray[i]="_-_";
      } else if (posesPerSection[i] === 3){
          sectionArray[i]= "_-_-_";
      }
    }
  }

  const poseLookup = [];

  for (var index=0; index<sectionCount; index++) {
    const sectionString = sectionArray[index]
    poseLookup[index] = (sectionString.length === 0) ? [] : sectionString.split("-");
  }

  return poseLookup;

}


export const convertPoseArrayIntoString = function(array = []){

  var string = "";

  for (var section=0; section<array.length; section++) {
      const poseArray = array[section];
      for (var i=0; i<poseArray.length; i++) {
          string = string + poseArray[i]

          if (i < poseArray.length - 1) {
            string = string + "-"
          }

      }

      if (section < array.length -1 ){
        string = string+"+"
      }

  }

  return string;

}



// WEBPACK FOOTER //
// ./src/helper.js